import { ReactNode } from 'react';
import './AppCenter.scss';

function AppCenter({ children }: { children: ReactNode }) {
  return <div className="stratus--app-center">{children}</div>;
}

export default AppCenter;
